import { AppActionTypes } from './actionTypes';

export const initiateAppLoad = () => ({
  type: AppActionTypes.INITIATE_APP_LOAD,
});

export const appLoaded = () => ({
  type: AppActionTypes.APP_LOADED,
});
